export default "__VITE_ASSET__Xe4hJbFT__"